import { defineStore } from 'pinia';

import { MarinLitDataService } from '@/api';
import {
  SET_ARTICLE_SERVICE_WAITING,
  UPDATE_ARTICLE_SEARCH_RESULTS,
  DELETE_ARTICLE_SEARCH_RESULTS,
} from '@/store/mutation-types';

export const useMarinLitImporterStore = defineStore('marinLitImporter', {

  // STATE
  state: () => ({
    SearchResults: [],
    ServiceStatus: {
      AwaitingResponse: false,
      HasError: false,
      Error: null,
    },
  }),

  // ACTIONS
  actions: {
    [SET_ARTICLE_SERVICE_WAITING]() {
      this.SearchResults = [];
      this.ServiceStatus.AwaitingResponse = true;
      this.ServiceStatus.HasError = false;
      this.ServiceStatus.Error = '';
    },

    [UPDATE_ARTICLE_SEARCH_RESULTS](payload) {
      if (payload.searchResults.Data) {
        this.SearchResults.push(...payload.searchResults.Data);
      }
      else {
        this.SearchResults = [];
      }
      this.ServiceStatus = payload.searchResults.ServiceStatus;
    },

    [DELETE_ARTICLE_SEARCH_RESULTS]() {
      this.SearchResults = [];
      this.ServiceStatus = {
        AwaitingResponse: false,
        HasError: false,
        Error: null,
      };
    },

    async updateSingleArticleSearchResultAction({ value, type }) {
      this[SET_ARTICLE_SERVICE_WAITING]();
      const searchResults = await MarinLitDataService.getSingleArticle(value, type);
      this[UPDATE_ARTICLE_SEARCH_RESULTS]({ searchResults });
    },

    async updateMultipleArticleSearchResultAction(value) {
      this[SET_ARTICLE_SERVICE_WAITING]();
      const searchResults = await MarinLitDataService.importArticlesFromBibtex(value);
      this[UPDATE_ARTICLE_SEARCH_RESULTS]({ searchResults });
    },

    clearArticleSearchResultsAction() {
      this[DELETE_ARTICLE_SEARCH_RESULTS]();
    },
  },

  // GETTERS
  getters: {
    isLoading: state => state.ServiceStatus.AwaitingResponse,
    newArticles: state => state.SearchResults.filter(r => !r.isDuplicate),
    duplicateArticles: state => state.SearchResults.filter(r => r.isDuplicate),
  },

});
